export enum SurveyType {
  ONBOARDING = 'onboarding',
  UNINSTALL = 'uninstall',
  HEATMAP_BETA = 'heatmap_beta',
}

export interface ITriggerSlackPayloadBase {
  name: string;
  email: string;
  domain: string;
  store_id: string;
}

export interface ISurveyOnboardingPayload {
  role: string;
  scenario: string;
}

export interface ISurveyUninstallPayload {
  reason: string;
  detailTitle: string;
  detailValue: string;
  detailFeedback: string;
}

export interface ISurveyHeatmapBetaPayload {
  // Field names must match the Slack workflow trigger's variables (store_id comes from the base
  // payload). store_name carries the shop domain — a store identifier, not the merchant's name.
  store_name: string;
  goal_using_heatmap: string;
}

interface SlackPayloadMap {
  [SurveyType.ONBOARDING]: ISurveyOnboardingPayload;
  [SurveyType.UNINSTALL]: ISurveyUninstallPayload;
  [SurveyType.HEATMAP_BETA]: ISurveyHeatmapBetaPayload;
}

export type IHandleTriggerSlack = <K extends SurveyType>(
  type: K,
  payload: SlackPayloadMap[K],
) => Promise<void>;
